// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import FunnelTimeSvg from '@rsuite/icon-font/lib/charts/FunnelTime';
var FunnelTime = createSvgIcon({
  as: FunnelTimeSvg,
  ariaLabel: 'funnel time',
  category: 'charts',
  displayName: 'FunnelTime'
});
export default FunnelTime;